<style scoped lang="scss">
  .note{
    display: flex;
    align-items: flex-start;
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
        font-size: 16px;
      }
    }
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .container100{
      margin-bottom: 20px!important;
    }
    .con{
      display: none!important;
    }
    .cons{
      display: block!important;
    }
    .cons .device{
      display: block!important;
    }
    .cons .device li{
      width: 100% !important;
      display: block!important;
      height: 385px;
    }
    .wrap-intel{
      margin-bottom: 0!important;
    }
    .wrap-intel .container{
      width: 90% !important;
    }
    .gene_img{
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .gene_img img{
      width: 100%;
    }
  }
  .cons{
    display: none;
  }

</style>
<template>
  <div class="wrap wrap-intel">
    <router-view></router-view>
    <div class="banner" v-if="!$route.meta.invisibles">
      <img src="@/assets/img/设备及原料/仪器设备/banner1.jpg" class="img-fluid">
      <div class="info">
<!--        <div class="container">-->
<!--          <h1>DNA/RNA合成设备</h1>-->
<!--          <h2 class="mt10">满足不同需求的DNA/RNA合成</h2>-->
<!--        </div>-->
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;" v-if="!$route.meta.invisibles">
      <bread></bread>
    </div>
    <section class="container" v-if="!$route.meta.invisibles">
      <div class="con">
        <ul class="device">
          <li>
            <img src="@/assets/images/compose12_2.png">
            <div class="info">
              <h4>单链核酸合成仪-12P</h4>
              <p>单链核酸合成仪-12P是一种经济，通用的低通量平台，循环时间短，试剂消耗低。</p>
              <router-link class="btn btn-primary" to="/intel/compose12">了解更多</router-link>
            </div>
          </li>
           <li>
            <img src="@/assets/images/compose24_1.png" width="250">
            <div class="info">
              <h4>单链核酸合成仪-24P</h4>
              <p>单链核酸合成仪-24P是一种经济，通用的低通量平台，循环时间短，试剂消耗低。</p>
              <router-link class="btn btn-primary" to="/intel/compose24">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/images/device_2.png">
            <div class="info">
              <h4>单链核酸合成仪-192</h4>
              <p>单链核酸合成仪-192是一种经济，通用的高通量平台，循环时间短，试剂消耗低。</p>
              <router-link class="btn btn-primary" to="/intel/compose192">了解更多</router-link>
            </div>
          </li>
          <li>
            <img src="@/assets/img/设备及原料/仪器设备/768合成仪-1.png">
            <div class="info">
              <h4>单链核酸合成仪-768</h4>
              <p>单链核酸合成仪-768是一种经济，通用的高通量平台，循环时间短，试剂消耗低。</p>
              <router-link class="btn btn-primary" to="/intel/compose768">了解更多</router-link>
            </div>
          </li>
        </ul>
      </div>
      <div class="cons">
        <ul class="device">
          <li>
            <div class="gene_img"><img src="@/assets/img/设备及原料/仪器设备/12合成仪.png"></div>
            <div class="info">
              <h4>单链核酸合成仪-12P</h4>
              <p>单链核酸合成仪-12P是一种经济，通用的低通量平台，循环时间短，试剂消耗低。</p>
              <router-link class="btn btn-primary" to="/intel/compose12">了解更多</router-link>
            </div>
          </li>
          <li>
            <div class="gene_img"><img src="@/assets/images/device_2.png"></div>
            <div class="info">
              <h4>单链核酸合成仪-192</h4>
              <p>单链核酸合成仪-192是一种经济，通用的高通量平台，循环时间短，试剂消耗低。</p>
              <router-link class="btn btn-primary" to="/intel/compose192">了解更多</router-link>
            </div>
          </li>
          <li>
            <div class="gene_img"><img src="@/assets/img/设备及原料/仪器设备/768合成仪-1.png"></div>
            <div class="info">
              <h4>单链核酸合成仪-768</h4>
              <p>单链核酸合成仪-768是一种经济，通用的高通量平台，循环时间短，试剂消耗低。</p>
              <router-link class="btn btn-primary" to="/intel/compose768">了解更多</router-link>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <qk-consult type="Virus1"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/intel/device_1.vue